import { interpolatePlaceholders } from './reportTextGeneration';

export type AssignmentDescriptionPlaceholders = {
  date: string;
  completedAt: string;
  projectName: string;
  address: string;
  city: string;
  clientName: string;
  mainContractor: string;
};

export function formatControlDateTime(value: string | Date | null | undefined) {
  if (!value) return '';

  const date = new Date(value);
  return (
    date.toLocaleDateString() +
    ' kl ' +
    date.toTimeString().split('GMT')[0].trim()
  );
}

export function interpolateAssignmentDescription(
  template: string,
  placeholders: AssignmentDescriptionPlaceholders
) {
  return interpolatePlaceholders(template, placeholders);
}
